<div class="page-header">
    <h2 class="page-title">
        <i class="fa-solid fa-clipboard-check"></i>
        {{ 'ReviewIndicatorsOutcomesProofs' | navTitle | async }}
    </h2>
    <button class="exit-btn" (click)="goBack()" pTooltip="{{'back'|translate}}" tooltipPosition="left">
        @if(dir=='rtl'){
        <i class="fa-solid fa-arrow-right"></i>
        }@else{
        <i class="fa-solid fa-arrow-left"></i>
        }
        <span>{{'back'|translate}}</span>
    </button>
</div>

<!-- Filters Section -->
<div class="filters-container">
    <div class="filter-row">
        <!-- Strategy Dropdown -->
        <div class="filter-section">
            <label class="filter-label">
                <i class="fa-solid fa-bullseye"></i>
                {{'strategy'|translate}}
            </label>
            <div class="strategy-dropdown-wrapper">
                <p-dropdown 
                    [options]="[]" 
                    placeholder="{{'select_strategy'|translate}}"
                    styleClass="modern-dropdown"
                    [disabled]="true">
                </p-dropdown>
            </div>
        </div>
        
        <!-- Search Input -->
        <div class="filter-section">
            <label class="filter-label">
                <i class="fa-solid fa-magnifying-glass"></i>
                {{'search'|translate}}
            </label>
            <div class="search-input-wrapper">
                <i class="fa-solid fa-magnifying-glass search-icon"></i>
                <input 
                    type="text" 
                    pInputText 
                    class="modern-search-input"
                    placeholder="{{'search'|translate}}..."
                    [(ngModel)]="searchQuery">
            </div>
        </div>
    </div>
</div>

<div class="table-container">

    <p-table #table [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20]" [class]="dir"
        [value]="mileStones" dataKey="id" [tableStyle]="{ 'width': '100%' }" styleClass="modern-assessment-table">

        <ng-template pTemplate="header">
            <tr>
                <th style="width: 5rem">
                    <i class="fa-solid fa-chevron-down"></i>
                </th>
                <th>
                    <i class="fa-solid fa-calendar-days"></i>
                    {{'cycle'|translate}}
                </th>
                <th>
                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                    {{'actions'|translate}}
                </th>
            </tr>

        </ng-template>


        <ng-template pTemplate="body" let-milestone let-expanded="expanded">
            <tr class="cursor-pointer" (click)="expanded ? table.toggleRow(milestone) : table.toggleRow(milestone)">
                <td>
                    <div>

                        <p-button (onClick)="expanded ? table.toggleRow(milestone) : table.toggleRow(milestone)"
                            type="button" pRipple [pRowToggler]="milestone" [text]="true" [rounded]="true"
                            [icon]="expanded ? 'pi pi-chevron-up':'pi pi-chevron-down'" />
                    </div>
                </td>
                <td class="font-bold">
                    {{ milestone.cycle }}
                </td>
                <td>
                    <a [routerLink]="['/strategies',1,'indicators',milestone.strategic_indicator_id]">
                        <p-button [text]="true" [plain]="true" pTooltip="{{'go_to_project' | translate}}" routerLinkActive="router-link-active">
                            @if(dir=='rtl'){
                            <i class="fa-solid fa-arrow-up-right-from-square fa-flip-horizontal"></i>
                            }@else{
                            <i class="fa-solid fa-arrow-up-right-from-square"></i>
                            }
                        </p-button>
                    </a>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-indicator>
            <tr>
                <td colspan="7">
                    <div class="p-3">
                        <p-table [value]="indicator.files" dataKey="id" styleClass="nested-files-table">
                            <ng-template pTemplate="header">
            <tr>
                <th>
                    <i class="fa-solid fa-file"></i>
                    {{'name'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-note-sticky"></i>
                    {{'notes'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-calendar-days"></i>
                    {{'cycle'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-check-circle"></i>
                    {{'proof_status'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-eye"></i>
                    {{'view'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-download"></i>
                    {{'download'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-list-check"></i>
                    {{'assess'|translate}}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-file>
            <tr>
                <td class="font-semibold">
                    <i class="{{getFileIcon(file.file_type)}}"></i>
                    <div class="white-space-nowrap overflow-hidden">
                        {{ file.file_name }}
                    </div>
                </td>
                <td>
                    {{file.comments}}
                </td>
                <td class="text-center">
                    {{ file.subEntityName }}
                </td>

                <!-- <td class="text-center">{{ file.file_type }}</td> -->
                <td class="text-center">
                    <div class="mr-3">


                        @if(dir=='rtl'){
                        @if(file.status=='approved'){
                        <p-tag severity="success" value="معتمد" />
                        }

                        @if(file.status=='rejected'){
                        <p-tag severity="danger" value="مرفوض" />
                        }

                        @if(file.status=='pending'){
                        <p-tag severity="warning" value="قيد المراجعة" />
                        }

                        }@else{

                        @if(file.status=='approved'){
                        <p-tag severity="success" value="{{file.status}}" />
                        }

                        @if(file.status=='rejected'){
                        <p-tag severity="danger" value="{{file.status}}" />
                        }

                        @if(file.status=='pending'){
                        <p-tag severity="warning" value="{{file.status}}" />
                        }
                        }

                    </div>




                </td>
                <td class="text-center">
                    <div class="table-action-icon cursor-pointer" (click)="openFileViewer(file)"
                        pTooltip="{{'view'|translate}}" tooltipPosition="top">
                        <i class="fa-solid fa-eye"></i>
                    </div>
                </td>
                <td class="text-center">
                    <div class="table-action-icon cursor-pointer" (click)="downloadFile(file)"
                        pTooltip="{{'download'|translate}}" tooltipPosition="top">
                        <i class="fa-solid fa-download"></i>
                    </div>
                </td>
                <td class="text-center">
                    <a [routerLink]="['/indicator-FileAuditsingle']" [queryParams]="{
                        strategyId: strategyId,
                        parentEntityId: indicatorId,
                        subEntityId: indicator.id
                    }">
                        <div class="table-action-icon cursor-pointer"
                            pTooltip="{{'output_assessment'|translate}}" tooltipPosition="top">
                            <i class="fa-solid fa-list-check"></i>
                        </div>
                    </a>
                </td>

            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-c>
            <tr>
                <td class="text-center font-bold text-lg text-red-500" [attr.colspan]="9">
                    <i class="fa-solid fa-circle-exclamation"></i>
                    {{'no_data_found' | translate}}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
</td>
</tr>
</ng-template>
</p-table>
</div>

@if(isFileViewer){
<p-dialog header="{{selectedFile?.file_name}}" [modal]="true" [(visible)]="isFileViewer" [style]="{ width: '90rem' }"
    [breakpoints]="{ '1199px': '90vw', '575px': '90vw' }" [maximizable]="true">
    <div>
        <web-viewer [fileUrl]="selectedFile"></web-viewer>
    </div>
</p-dialog>

}